import { z } from 'zod';
import { parse, isValid } from 'date-fns';
import { intervalMap } from '@/contracts/utils/labelFormatting.ts';

const dateStringValidator = z
  .string()
  .transform((date) => {
    const parsedDate = parse(date, 'dd.MM.yyyy', new Date());
    if (isValid(parsedDate)) return date;
    return null;
  })
  .nullable();

const zahlweiseValidator = z
  .string()
  .transform((value: string): number | null => {
    const zahlweise = intervalMap.get(value);
    if (!zahlweise) return null;

    return zahlweise;
  })
  .nullable();

export const ExtractDocumentResponseSchema = z.object({
  vertragsnummer: z.string().nullable(),
  beginn: dateStringValidator,
  ablauf: dateStringValidator,
  beitrag: z.number().nullable(),
  contractId: z.number().nullable(),
  gesellschaftId: z.number().nullable(),
  sparteId: z.number().nullable(),
  zahlweise: zahlweiseValidator,
});

export type ParsedExtractDocumentResponse = z.infer<typeof ExtractDocumentResponseSchema>;
